import { render } from "./Promos.vue?vue&type=template&id=c39474c8&scoped=true"
import script from "./Promos.vue?vue&type=script&lang=js"
export * from "./Promos.vue?vue&type=script&lang=js"

import "./Promos.vue?vue&type=style&index=0&id=c39474c8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c39474c8"]])

export default __exports__